import { CompanyLanguage } from "app/shared/models/standard.models";

export class RRULETRANSLATE {
    /**
     * Work-around translation of RRule texts, for user's benefit without the cost.
     * Will not return linguistically correct texts.
     * Languages availabe are [ "da-DK", "de-DE", "es-ES", "fo-FO", "nn-NO", "sv-SE" ].
     * The original English will be returned if language not available.
     * 
     * @param text RRule.toText() output
     * @param language 
     * @returns Brute force translated string. Grammatically incorrect.
     */
    static rruleTranslation(text: string, language: CompanyLanguage): string {
        const lingo = this.getLanguage(language);
        if (lingo && text) {
            return text.replace(/,/g, ' ,')
                .split(' ')
                .map((word, index) =>  { 
                        return index == 0 && lingo[word.toLowerCase()] ? ( lingo[word.toLowerCase()][0].toUpperCase() + lingo[word.toLowerCase()].slice(1) || word ) : 
                        ( lingo[word.toLowerCase()] || word )
                        } 
                    ).join(' ');
        }
        return text;
    };
    static getLanguage(language:string){
        switch(language){
            case 'da-DK': {
                return {
                'every': 'hver',
                'day': 'dag',
                'days': 'dage',
                'weekday': 'hverdag',
                'weekdays': 'hverdage',
                'week': 'uge',
                'weeks': 'uger',
                'hour': 'time',
                'hours': 'timer',
                'minute': 'minut',
                'minutes': 'minutter',
                'month': 'måned',
                'months': 'måneder',
                'year': 'år',
                'years': 'år',
                'on': 'på',
                'at': 'kl.',
                'the': 'den',
                'first': 'første',
                'second': 'anden',
                'third': 'tredje',
                'last': 'sidste',
                'for': 'for',
                'time': 'gang',
                'times': 'gange',
                'until': 'indtil',
                'monday': 'mandag',
                'tuesday': 'tirsdag',
                'wednesday': 'onsdag',
                'thursday': 'torsdag',
                'friday': 'fredag',
                'saturday': 'lørdag',
                'sunday': 'søndag',
                'january': 'januar',
                'february': 'februar',
                'march': 'marts',
                'april': 'april',
                'may': 'maj',
                'june': 'juni',
                'july': 'juli',
                'august': 'august',
                'september': 'september',
                'october': 'oktober',
                'november': 'november',
                'december': 'december',
                ',': ',',
                'and': 'og',
                'or': 'eller',
                '1st': '1.',
                '2nd': '2.',
                '3rd': '3.'
            };
        }
            case 'nn-NO': {
                return {
                    'every': 'hver',
                    'day': 'dag',
                    'days': 'dager',
                    'weekday': 'ukedag',
                    'weekdays': 'ukedager',
                    'week': 'uke',
                    'weeks': 'uker',
                    'hour': 'time',
                    'hours': 'timer',
                    'minute': 'minutt',
                    'minutes': 'minutter',
                    'month': 'måned',
                    'months': 'måneder',
                    'year': 'år',
                    'years': 'år',
                    'on': 'på',
                    'at': 'kl.',
                    'the': 'den',
                    'first': 'første',
                    'second': 'andre',
                    'third': 'tredje',
                    'last': 'siste',
                    'for': 'for',
                    'time': 'gang',
                    'times': 'ganger',
                    'until': 'til',
                    'monday': 'mandag',
                    'tuesday': 'tirsdag',
                    'wednesday': 'onsdag',
                    'thursday': 'torsdag',
                    'friday': 'fredag',
                    'saturday': 'lørdag',
                    'sunday': 'søndag',
                    'january': 'januar',
                    'february': 'februar',
                    'march': 'mars',
                    'april': 'april',
                    'may': 'mai',
                    'june': 'juni',
                    'july': 'juli',
                    'august': 'august',
                    'september': 'september',
                    'october': 'oktober',
                    'november': 'november',
                    'december': 'desember',
                    ',': ',',
                    'and': 'og',
                    'or': 'eller',
                    '1st': '1.',
                    '2nd': '2.',
                    '3rd': '3.'
                };
            }
            case 'sv-SE': {
                return {
                    'every': 'varje',
                    'day': 'dag',
                    'days': 'dagar',
                    'weekday': 'veckodag',
                    'weekdays': 'veckodagar',
                    'week': 'vecka',
                    'weeks': 'veckor',
                    'hour': 'timme',
                    'hours': 'timmar',
                    'minute': 'minut',
                    'minutes': 'minuter',
                    'month': 'månad',
                    'months': 'månader',
                    'year': 'år',
                    'years': 'år',
                    'on': 'på',
                    'at': 'kl.',
                    'the': 'den',
                    'first': 'första',
                    'second': 'andra',
                    'third': 'tredje',
                    'last': 'sista',
                    'for': 'för',
                    'time': 'gång',
                    'times': 'gånger',
                    'until': 'till',
                    'monday': 'måndag',
                    'tuesday': 'tisdag',
                    'wednesday': 'onsdag',
                    'thursday': 'torsdag',
                    'friday': 'fredag',
                    'saturday': 'lördag',
                    'sunday': 'söndag',
                    'january': 'januari',
                    'february': 'februari',
                    'march': 'mars',
                    'april': 'april',
                    'may': 'maj',
                    'june': 'juni',
                    'july': 'juli',
                    'august': 'augusti',
                    'september': 'september',
                    'october': 'oktober',
                    'november': 'november',
                    'december': 'december',
                    ',': ',',
                    'and': 'och',
                    'or': 'eller',
                    '1st': '1:a',
                    '2nd': '2:a',
                    '3rd': '3:e'
                };
            }
            case 'es-ES': {
                return {
                    'every': 'cada',
                    'day': 'día',
                    'days': 'días',
                    'weekday': 'día de la semana',
                    'weekdays': 'días de la semana',
                    'week': 'semana',
                    'weeks': 'semanas',
                    'hour': 'hora',
                    'hours': 'horas',
                    'minute': 'minuto',
                    'minutes': 'minutos',
                    'month': 'mes',
                    'months': 'meses',
                    'year': 'año',
                    'years': 'años',
                    'on': 'en',
                    'at': 'a las',
                    'the': 'el',
                    'first': 'primer',
                    'second': 'segundo',
                    'third': 'tercer',
                    'last': 'último',
                    'for': 'por',
                    'time': 'vez',
                    'times': 'veces',
                    'until': 'hasta',
                    'monday': 'lunes',
                    'tuesday': 'martes',
                    'wednesday': 'miércoles',
                    'thursday': 'jueves',
                    'friday': 'viernes',
                    'saturday': 'sábado',
                    'sunday': 'domingo',
                    'january': 'enero',
                    'february': 'febrero',
                    'march': 'marzo',
                    'april': 'abril',
                    'may': 'mayo',
                    'june': 'junio',
                    'july': 'julio',
                    'august': 'agosto',
                    'september': 'septiembre',
                    'october': 'octubre',
                    'november': 'noviembre',
                    'december': 'diciembre',
                    ',': ',',
                    'and': 'y',
                    'or': 'o',
                    '1st': '1º',
                    '2nd': '2º',
                    '3rd': '3º'
                };
            }
            case 'de-DE': {
                return {
                    'every': 'jeden',
                    'day': 'Tag',
                    'days': 'Tage',
                    'weekday': 'Wochentag',
                    'weekdays': 'Wochentage',
                    'week': 'Woche',
                    'weeks': 'Wochen',
                    'hour': 'Stunde',
                    'hours': 'Stunden',
                    'minute': 'Minute',
                    'minutes': 'Minuten',
                    'month': 'Monat',
                    'months': 'Monate',
                    'year': 'Jahr',
                    'years': 'Jahre',
                    'on': 'am',
                    'at': 'um',
                    'the': 'der',
                    'first': 'erster',
                    'second': 'zweiter',
                    'third': 'dritter',
                    'last': 'letzter',
                    'for': 'für',
                    'time': 'Mal',
                    'times': 'Male',
                    'until': 'bis',
                    'monday': 'Montag',
                    'tuesday': 'Dienstag',
                    'wednesday': 'Mittwoch',
                    'thursday': 'Donnerstag',
                    'friday': 'Freitag',
                    'saturday': 'Samstag',
                    'sunday': 'Sonntag',
                    'january': 'Januar',
                    'february': 'Februar',
                    'march': 'März',
                    'april': 'April',
                    'may': 'Mai',
                    'june': 'Juni',
                    'july': 'Juli',
                    'august': 'August',
                    'september': 'September',
                    'october': 'Oktober',
                    'november': 'November',
                    'december': 'Dezember',
                    ',': ',',
                    'and': 'und',
                    'or': 'oder',
                    '1st': '1.',
                    '2nd': '2.',
                    '3rd': '3.'
                };
            }
            case 'fo-FO': {
                return {
                    'every': 'hvør',
                    'day': 'dag',
                    'days': 'dagar',
                    'weekday': 'virkidag',
                    'weekdays': 'virkidagar',
                    'week': 'vika',
                    'weeks': 'vikur',
                    'hour': 'tími',
                    'hours': 'tímar',
                    'minute': 'minutt',
                    'minutes': 'minuttir',
                    'month': 'mánað',
                    'months': 'mánaðir',
                    'year': 'ár',
                    'years': 'ár',
                    'on': 'á',
                    'at': 'kl.',
                    'the': 'hin',
                    'first': 'fyrsta',
                    'second': 'næsta',
                    'third': 'tríðja',
                    'last': 'seinasta',
                    'for': 'í',
                    'time': 'ferð',
                    'times': 'ferðir',
                    'until': 'til',
                    'monday': 'mánadag',
                    'tuesday': 'týsdag',
                    'wednesday': 'mikudag',
                    'thursday': 'hósdag',
                    'friday': 'fríggjadag',
                    'saturday': 'leygardag',
                    'sunday': 'sunnudag',
                    'january': 'januar',
                    'february': 'februar',
                    'march': 'mars',
                    'april': 'apríl',
                    'may': 'mai',
                    'june': 'juni',
                    'july': 'juli',
                    'august': 'august',
                    'september': 'september',
                    'october': 'oktober',
                    'november': 'november',
                    'december': 'desember',
                    ',': ',',
                    'and': 'og',
                    'or': 'ella',
                    '1st': '1.',
                    '2nd': '2.',
                    '3rd': '3.'
                };
            }
            default : { return null }
        }
    }
}



